export default function LoadingScreen({ visible }) {
  return (
    <div
      className="ls-overlay position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center gap-4"
      style={{ opacity: visible ? 1 : 0, pointerEvents: visible ? 'all' : 'none' }}
    >
      <div className="ls-icon">🏆</div>

      <h1 className="ls-title fw-bold text-center px-4 mb-0">
        {process.env.REACT_APP_EVENT_NAME || 'Awards Platform'}
      </h1>

      <div className="ls-bar-wrap overflow-hidden rounded-pill">
        <div className="ls-shimmer h-100 rounded-pill" />
      </div>

      <p className="ls-sub small mb-0">
        Loading your experience…
      </p>
    </div>
  );
}
